import { IconAppWindow, IconBell, IconBrandGoogleAnalytics, IconBrandHipchat, IconDeviceTabletDollar, IconHome, IconId, IconLink, IconMessageReport, IconPasswordUser, IconPower, IconQrcode, IconSettingsCog, IconTemplate, IconUser, IconUserShield } from '@tabler/icons-react';
import React, { memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { accessKeys } from '../../statics/accessKeys';
import { accessCheck } from '../../utils/accessCheck';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

const SideMenu = memo(function SideMenu({ isOpen }) {

    const { pathname } = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        {
            id: 1,
            name: 'Dashboard',
            link: '/dashboard',
            icon: <IconHome size={20} />,
            active: pathname.includes('dashboard'),
            access: true || (accessCheck(accessKeys.getTotalNewsCount) || accessCheck(accessKeys.getTotalShareCount) || accessCheck(accessKeys.getTotalLikeCount) || accessCheck(accessKeys.getTotalViewsCount) || accessCheck(accessKeys.getTotalUserCount) || accessCheck(accessKeys.getAllPollCount))
        }, {
            id: 2,
            name: 'Users',
            link: '/users',
            icon: <IconUser size={20} />,
            active: pathname.includes('user'),
            access: true || accessCheck(accessKeys.getUserList)
        },
        {
            id: 3,
            name: 'Admins',
            link: '/admins',
            icon: <IconUserShield size={20} />,
            active: pathname.includes('admins'),
            access: true || accessCheck(accessKeys.getAdminList)
        }, {
            id: 4,
            name: 'Links',
            link: '/links',
            icon: <IconLink size={20} />,
            active: pathname.includes('links'),
            access: true || accessCheck(accessKeys.getAllNews)
        }, {
            id: 5,
            name: 'QR Codes',
            link: '/qr-codes',
            icon: <IconQrcode size={20} />,
            active: pathname.includes('qr'),
            access: true || accessCheck(accessKeys.getAllPoll)
        }, {
            id: 6,
            name: 'Pages',
            link: '/pages',
            icon: <IconAppWindow size={20} />,
            active: pathname.includes('pages'),
            access: true || accessCheck(accessKeys.getAllCategoryList)
        }, {
            id: 11,
            name: 'Templates',
            link: '/templates',
            icon: <IconTemplate size={20} />,
            active: pathname.includes('templates'),
            access: true
        }, {
            id: 7,
            name: 'Business Cards',
            link: '/business-cards',
            icon: <IconId size={20} />,
            active: pathname.includes('business-card'),
            access: true || accessCheck(accessKeys.getAllNews)
        }, {
            id: 8,
            name: 'Withdraw Requests',
            link: '/withdraw-request',
            icon: <IconDeviceTabletDollar size={20} />,
            active: pathname.includes('withdraw-request'),
            access: true || accessCheck(accessKeys.getAllLanguage)
        }, {
            id: 9,
            name: 'Notification',
            link: '/notification',
            icon: <IconBell size={20} />,
            active: pathname.includes('notification'),
            access: true || accessCheck(accessKeys.getAllNotificationTopics)
        }, {
            id: 10,
            name: 'Feedback & Report',
            link: '/feedback',
            icon: <IconMessageReport size={20} />,
            active: pathname.includes('feedback'),
            access: true || accessCheck(accessKeys.homePageDataList)
        }, {
            id: 13,
            name: 'Plan Request',
            link: '/plan-request',
            icon: <IconPasswordUser size={20} />,
            active: pathname.includes('plan-request'),
            access: true || accessCheck(accessKeys.homePageDataList)
        }, {
            id: 14,
            name: 'Chat Purchased List',
            link: '/chat-purchased-list',
            icon: <IconBrandHipchat size={20} />,
            active: pathname.includes('chat-purchased-list'),
            access: true || accessCheck(accessKeys.homePageDataList)
        }, {
            id: 15,
            name: 'Google-Ads Account Request',
            link: '/google-ads-account-request',
            icon: <IconBrandGoogleAnalytics size={20} />,
            active: pathname.includes('google-ads-account-request'),
            access: true || accessCheck(accessKeys.homePageDataList)
        }, {
            id: 12,
            name: 'Settings',
            link: '/settings',
            icon: <IconSettingsCog size={20} />,
            active: pathname.includes('settings'),
            access: true
        }
    ];

    function onLogout() {
        localStorage.removeItem('advy-admin-token');
        localStorage.removeItem('admin-access-list')
        navigate('/login');
    }

    return (
        <aside className="sidebar h-screen bg-primary-background absolute z-[2]"
            style={{ width: "200px", padding: isOpen ? '12px' : '0px', transition: 'all 0.3s ease-in-out', left: isOpen ? 0 : '-200px' }}>

            <img src={process.env.PUBLIC_URL + "/assets/images/nav-logo.png"} alt="logo" className='mb-6 mx-auto' />

            <div className="menu-items overflow-y-auto overflow-x-hidden" style={{ height: 'calc(100% - 70px )' }}>
                {
                    menuItems?.filter(item => item.access)?.map((menu, index) => {
                        return (
                            menu.access && <Link to={menu.link} key={menu.id} className="flex items-center px-[10px] py-[8px] text-sm font-medium text-white mb-2 rounded-lg hover:bg-primary-text hover:text-white transition-all" style={{ backgroundColor: menu.active && 'var(--secondary-gradient-1)', color: menu.active && 'white' }} >
                                {menu.icon}
                                <span className="ml-2">{menu.name}</span>
                            </Link>
                        )
                    })
                }
                <ConfirmationModal
                    buttonComponent={<div className="flex items-center px-[12px] py-[8px] text-md font-medium text-white mb-2 rounded-lg hover:bg-primary-text hover:text-white transition-all" >
                        <IconPower color='var(--secondary)' size={20} />
                        <span className="ml-2 text-sm">Logout</span>
                    </div>}
                    confirmationText={`Are You Sure Want To Logout ?`}
                    onConfirm={() => onLogout()}
                />
            </div>

        </aside>
    )
})

export default SideMenu